namespace RedBullMOBILE360.Administration {
    export class LanguageColumns {
        static columnsKey = 'Administration.Language';
    }
}
